import React from 'react';
import { IOldIconProps } from './type';

const SocialTwitter: React.FC<IOldIconProps> = ({
  width,
  height,
  color = '#000',
  ...props
}) => {
  return (
    <svg
      width={width || 32}
      height={height || 32}
      viewBox="0 0 21 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M20.334 2.864a7.924 7.924 0 01-2.357.676 4.277 4.277 0 001.805-2.375 8 8 0 01-2.606 1.042A4.016 4.016 0 0014.18.852c-2.266 0-4.103 1.921-4.103 4.291 0 .336.036.664.106.978-3.41-.179-6.434-1.887-8.458-4.484a4.422 4.422 0 00-.555 2.158c0 1.489.724 2.802 1.825 3.572a3.952 3.952 0 01-1.858-.537v.054c0 2.08 1.414 3.814 3.29 4.208a3.939 3.939 0 01-1.852.074c.522 1.705 2.037 2.946 3.833 2.98a8.006 8.006 0 01-6.075 1.777 11.247 11.247 0 006.29 1.929c7.547 0 11.675-6.54 11.675-12.211 0-.186-.005-.371-.012-.555a8.56 8.56 0 002.047-2.222z"
        fill={color}
      />
    </svg>
  );
};

export default SocialTwitter;
